export default "<svg viewBox=\"0 0 24 22\"><path d=\"M22,2V15H10.36L6,18.1V15H2V2Zm2-2H0V17H4v5l7-5H24Z\"/></svg>";